import React from 'react';
import { MathJaxContext } from 'better-react-mathjax';
import './FlipCardQA.css'; // Custom CSS for flip logic
import { renderBlocks } from '../components/renderBlocks'; // ✅ Import the shared block renderer

const FlipCardQA = ({ items }) => {
  if (!items || items.length === 0) {
    return <div className="text-center text-gray-500 mt-10">No learning content available.</div>;
  }

  return (
    <MathJaxContext>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {items.map((item, index) => (
          <div key={item.id || index} className="flip-card">
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <h3 className="text-indigo-700 font-semibold mb-2">Q{item.order_index}</h3>
                <div className="text-gray-700 text-sm overflow-y-auto max-h-40">
                  {item.question_blocks
                    ? renderBlocks(item.question_blocks)
                    : renderBlocks([{ type: 'text', value: item.question }])
                  }
                </div>
              </div>
              <div className="flip-card-back">
                <p className="font-semibold text-indigo-800 mb-2">Answer:</p>
                <div className="text-gray-700 text-sm overflow-y-auto max-h-40">
                  {item.answer_blocks
                    ? renderBlocks(item.answer_blocks)
                    : renderBlocks([{ type: 'text', value: item.answer }])
                  }
                </div>
                {item.hint && (
                  <div className="text-sm text-gray-500 mt-2">
                    <strong>Hint:</strong> {item.hint}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </MathJaxContext>
  );
};

export default FlipCardQA;
